<template>
	<div class="delivery-info-sheet">
		<AppBottomSheet :forceWidth="bottomSheetWidth" :active="ordersStore.deliveryOrderInfo !== null" @toggling-popup="toggleBottomSheet">
			<div class="delivery-info-sheet-content" v-if="ordersStore.deliveryOrderInfo">
				<ModalHeader :title="getString('delivery_info')"></ModalHeader>
				<AppList :items="deliveryInfoItems" />
			</div>
		</AppBottomSheet>
	</div>
</template>

<script>
import {useOrdersStore} from "@/console-new/stores";
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import AppList from "@/shared/components/AppList.vue";
import {useLanguageStore} from "@/shared/stores";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import WindowWidth from "@/console-new/mixins/WindowWidth";
import AppButton from "@/shared/components/AppButton.vue";

export default {
	components: {AppButton, ModalHeader, AppList, AppBottomSheet},
	setup() {
		const ordersStore = useOrdersStore();
		const languageStore = useLanguageStore();
		return {
			ordersStore,
			getString: languageStore.getString,
		}
	},
	mixins: [WindowWidth],
	name: "DeliveryInfoSheet",
	computed: {
		bottomSheetWidth() {
			if (this.windowWidth < 550) {
				return "100%";
			} else if (this.windowWidth < 768) {
				return "550px";
			} else {
				return "720px";
			}
		},
		deliveryInfoItems() {
			let items = [
				{
					title: this.getString("customer_name"),
					rightText: this.ordersStore.deliveryOrderInfo.customer_name,
					rightPrimaryText: true,
					leftGreyText: true,
				},
				{
					title: this.getString("customer_phone"),
					rightText: this.ordersStore.deliveryOrderInfo.customer_phone,
					rightPrimaryText: true,
					leftGreyText: true,
				},
				{
					title: this.getString("address"),
					rightText: this.ordersStore.deliveryOrderInfo.address,
					rightPrimaryText: true,
					leftGreyText: true,
				},
			];
			if(this.ordersStore.deliveryOrderInfo.address_details) {
				items.push({
					title: this.getString("address_details"),
					rightText: this.ordersStore.deliveryOrderInfo.address_details,
					rightPrimaryText: true,
					leftGreyText: true,
				});
			}
			if(this.ordersStore.deliveryOrderInfo.delivery_date) {
				items.push({
					title: this.getString("delivery_date"),
					rightText: this.ordersStore.deliveryOrderInfo.delivery_date,
					rightPrimaryText: true,
					leftGreyText: true,
				});
			}
			if(this.ordersStore.deliveryOrderInfo.label_url && this.ordersStore.deliveryOrderInfo.rate) {
				items.push({
					title: this.getString("shipping_label"),
					leftGreyText: true,
					buttonTitle: this.getString("download"),
					callbackButton: this.downloadShippingLabel,
				});
			}
			if(this.ordersStore.deliveryOrderInfo.tracking_url) {
				items.push({
					title: this.getString("tracking_url"),
					leftGreyText: true,
					buttonTitle: this.getString("tracking"),
					callbackButton: () => window.open(this.ordersStore.deliveryOrderInfo.tracking_url, '_blank'),
				});
			}
			return items;
		}
	},
	methods: {
		toggleBottomSheet(open) {
			if(!open) {
				this.ordersStore.deliveryOrderInfo = null;
			}
		},
		downloadShippingLabel() {
			if(this.ordersStore.deliveryOrderInfo.label_url && this.ordersStore.deliveryOrderInfo.rate) {
				let url = this.ordersStore.deliveryOrderInfo.label_url;
				let filename = this.ordersStore.deliveryOrderInfo.rate.carrier + "_" + this.ordersStore.deliveryOrderInfo.rate.service + "_" + (this.ordersStore.deliveryOrderInfo.orderNumberDayFormatted || "0") + ".pdf";
				let link = document.createElement('a');
				link.href = url;
				link.download = filename;
				link.target = "_blank";
				link.dispatchEvent(new MouseEvent('click'));
			}
		},
	}
}
</script>

<style scoped lang="scss">
.delivery-info-sheet-content {


}
</style>